import axios from 'axios';
import { BASE_URL } from 'constants/index';

export const CREATE_FIREWALL = async (e) => {
  const res = await axios.post(BASE_URL + `/vs/firewall`, e);
  return res.data;
};

export const DELETE_FIREWALL = async (e) => {
  const res = await axios.delete(BASE_URL + `/vs/firewall/${e.id}`);
  return res.data;
};

export const DELETE_ALL_RULES = async (e) => {
  const res = await axios.post(BASE_URL + `/vs/firewall/${e.id}`, { action: e.action });
  return res.data;
};

export const ADD_RULES = async (e, id) => {
  const res = await axios.put(BASE_URL + `/vs/firewall/${id}`, e);
  return res.data;
};

export const CREATE_OBJECT = async (e) => {
  const res = await axios.post(BASE_URL + `/vs/firewall/object`, e);
  return res.data;
};


export const DELETE_ALL_OBJECT = async (e) => {
  const res = await axios.post(BASE_URL + `/vs/firewall/object/${e.id}`, { action: e.action });
  return res.data;
};

export const ADD_OBJECTS = async (e, id) => {
  const res = await axios.put(BASE_URL + `/vs/firewall/object/${id}`, e);
  return res.data;
};
